import { customFetch } from '@skytech/auth'
import { config } from '@skytech/config'

const authFetchConfig = {
  credentials: 'include' as const,
  environment: config.AUTH_API_URL,
}

const authResources = {
  getSettings: ({ phoneNumber, phoneCountryId }: { phoneCountryId: number; phoneNumber: string }) =>
    customFetch<{
      isAccessCodeRequired: boolean
      isPasswordRequired: boolean
      hasMsalLogin: boolean
      phoneCountryId: number
    }>({
      path: `manager/authenticate/settings/${phoneCountryId}/${phoneNumber}`,
      ...authFetchConfig,
    }),

  // Mutations
  logIn: (args: {
    phoneNumber: string
    phoneCountryId: number
    password?: string
    accessCode?: string
  }) => {
    const { phoneCountryId, ...payload } = args
    return customFetch<{
      token: string
    }>({
      path: 'manager/authenticate',
      method: 'POST',
      data: { ...payload, countryId: phoneCountryId },
      ...authFetchConfig,
    })
  },
  generatePassword: ({ phoneNumber, countryId }: { phoneNumber: string; countryId: number }) =>
    customFetch<null>({ path: `manager/${countryId}/${phoneNumber}/key/generate`, method: 'POST' }),
  deleteRefreshToken: () =>
    customFetch<{ token: string }>({
      method: 'DELETE',
      path: 'manager/token',
      ...authFetchConfig,
    }),
}

export default authResources
